import React from "react";

import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import { saveEntityProfileSelectedToIndexedDB ,removeFromIndexedDB} from "../../../storage/profileStorage";
import CardCheckbox from "../../../components/Cardcheckbox";
import SectionHeading from "../../../Containers/DashBoardView/SectionHeading";
import { ComponentType, EntityType } from "../../../common/enum";

import {
  boxStyles,
  buttonStyles,
  cardcheckboxStyles,
  paperStyles,
} from "./styles";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setEntityProfileSelect } from "../../../Containers/DashBoardView/slice";

const profileLogged = [
  {
    title: "profileDonor",
    icon: "/static/register/donor.png",
    value: EntityType.donor,
  },
  {
    title: "profileDistributor",
    icon: "/static/register/donorReciever.png",
    value: EntityType.distributor,
  },
];

const ProfileSelector = ({ open, setOpen, component, t }) => {
  const handleClose = React.useCallback(() => setOpen(false), [setOpen]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleProfile = React.useCallback(
    (value) => {
      if (component === ComponentType.LOG_IN) {
        navigate("/dashboard", { replace: true });
      }
      dispatch(setEntityProfileSelect(value));
      removeFromIndexedDB("entityProfileSelect", "entityProfileSelect");
      saveEntityProfileSelectedToIndexedDB(value)
      setOpen(false);
      // window.location.reload();
    },
    [component]
  );

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Paper sx={paperStyles}>
        <Stack spacing={3}>
          <Box sx={boxStyles}>
            <SectionHeading
              heading={"profileSelectorHeading"}
              subHeading={"profileSelectorSubHeading"}
              t={t}
            />
            <Button sx={buttonStyles} onClick={handleClose}>
              <CloseIcon sx={{ color: "#FF0000" }} />
            </Button>
          </Box>
          <Box sx={cardcheckboxStyles}>
            {profileLogged.map((item) => (
              <CardCheckbox
                title={`${t(item.title)}`}
                icon={item.icon}
                clickHandler={() => handleProfile(item.value)}
                subtitle={""}
                
                sx={{
                  border: "1px solid #EEEEEE",
                  margin: "0",
                  marginLeft: item.title == "profileDistributor" ? "8px" : "0"
                }}
                key={item.title}
              />
            ))}
          </Box>
        </Stack>
      </Paper>
    </Modal>
  );
};

export default ProfileSelector;
